import { getValue, setValue } from '_core/utils/storage';

// Keep it small and safe: store only file meta, not base64.
const STORAGE_OPTIONS = { encode: false, prefixKey: true };
const KEY_PREFIX = 'visitor-avatar';

const keyByVisitorId = (visitorId) => `${KEY_PREFIX}.${visitorId || 0}`;

export const getLocalVisitorAvatar = (visitorId) => {
  if (!visitorId) return null;
  const value = getValue(keyByVisitorId(visitorId), STORAGE_OPTIONS);
  if (!value || typeof value !== 'object') return null;

  if (value.cleared === true) {
    return { cleared: true };
  }

  const id = Number(value.id || 0);
  const path = typeof value.path === 'string' ? value.path : null;

  if (!path) return null;
  return { id, path };
};

const dispatch = (visitorId) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent('local-visitor-avatar', { detail: { visitorId } })
  );
};

const previewKeyByVisitorId = (visitorId) => `${KEY_PREFIX}.preview.${visitorId || 0}`;

export const getLocalVisitorAvatarPreview = (visitorId) => {
  if (!visitorId) return null;
  const value = getValue(previewKeyByVisitorId(visitorId), STORAGE_OPTIONS);
  if (!value || typeof value !== 'object') return null;
  if (typeof value.dataUrl !== 'string' || !value.dataUrl) return null;
  return {
    photoId: Number(value.photoId || 0),
    dataUrl: value.dataUrl
  };
};

export const setLocalVisitorAvatarPreview = (visitorId, photoId, dataUrl) => {
  if (!visitorId || !photoId || typeof dataUrl !== 'string' || !dataUrl) return;

  try {
    setValue(
      previewKeyByVisitorId(visitorId),
      { photoId: Number(photoId), dataUrl, updatedAt: Date.now() },
      STORAGE_OPTIONS
    );
  } catch (e) {
    // QuotaExceededError etc — skip persistence safely
    process.env.NODE_ENV !== 'production' && console.warn(e);
  }
};

export const clearLocalVisitorAvatarPreview = (visitorId) => {
  if (!visitorId) return;
  try {
    setValue(previewKeyByVisitorId(visitorId), null, STORAGE_OPTIONS);
  } finally {
    // not required but keeps UI consistent if we rely on preview
    dispatch(visitorId);
  }
};

export const setLocalVisitorAvatar = (visitorId, avatar) => {
  if (!visitorId) return;

  if (!avatar) return;

  const payload = {
    id: Number(avatar.id || 0),
    path: avatar.path,
    cleared: false,
    updatedAt: Date.now()
  };

  try {
    setValue(keyByVisitorId(visitorId), payload, STORAGE_OPTIONS);
  } catch (e) {
    // If localStorage quota is exceeded or storage is blocked, just skip persistence.
    process.env.NODE_ENV !== 'production' && console.warn(e);
  } finally {
    dispatch(visitorId);
  }
};

export const setLocalVisitorAvatarCleared = (visitorId) => {
  if (!visitorId) return;
  try {
    setValue(
      keyByVisitorId(visitorId),
      { cleared: true, updatedAt: Date.now() },
      STORAGE_OPTIONS
    );
  } catch (e) {
    process.env.NODE_ENV !== 'production' && console.warn(e);
  } finally {
    dispatch(visitorId);
  }
};

export const clearLocalVisitorAvatar = (visitorId) => {
  if (!visitorId) return;
  setValue(keyByVisitorId(visitorId), null, STORAGE_OPTIONS);
  dispatch(visitorId);
};

